import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Controller, useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getCurrencyFrom, getCurrencyTo,
    getSources
} from "./ExchangeClient";
import {changeExchange} from "./exchangeSlice";
import {changeExchangeSearch} from "./exchangeSearchSlice";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";
import {changeInterestSearch} from "../Interest/interestSearchSlice";
// import {getCurrencyFrom, getCurrencyTos} from "../CurrencyFrom/ExchangeClient";




export default function ExchangeSearch({gridClear}) {

    const { register, handleSubmit, setValue, reset, control } = useForm();
    // const {register, handleSubmit} = useForm();
    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const [currencyFromDropdown, setCurrencyFromDropdown] = useState([]);
    const [selectedCurrencyFrom, setSelectedCurrencyFrom] = useState([]);
    const [initialMarketDropdown, setInitialMarketDropdown] = useState([]);
    const [selectedIsActive, setSelectedIsActive] = useState(null);
    const [currencyToDropdown, setCurrencyToDropdown] = useState([]);
    const [selectedCurrencyTo, setSelectedCurrencyTo] = useState([]);
    const [sourceDropdown, setSourceDropdown] = useState([]);
    const [selectedSource, setSelectedSource] = useState([]);
    const [exchangeValue, setExchangeValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [exchanges, setExchanges] = useState([]);

    const selectorIsActive = useSelector(
        (state) => state.interestSearchSlc.value.isActive
    );

    const handleClearClick = () => {
        setExchangeValue("");
    };



    const fetchCurrencyFrom = () =>
        getCurrencyFrom()

            .then(data => {
                console.log("Currency From");
                console.log(data);
                console.log("Currency From with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setCurrencyFromDropdown(data);
            })


    const fetchCurrencyTo = () =>
        getCurrencyTo()
            .then(data => {
                console.log("Currency To");
                console.log(data);
                console.log("Currency To with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setCurrencyToDropdown(data);
            })

    const fetchSources = () =>
        getSources()

            .then(data => {
                console.log("Production Types");
                console.log(data);
                console.log("Production Types with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setSourceDropdown(data);
            })


    useEffect(() => {
        console.log("This is for the dropdowns...");
        fetchCurrencyFrom();
        fetchCurrencyTo();
        fetchSources();
    }, []);

    const [isActiveDropdown, setIsActiveDropdown] = useState("");

    const options = ["Yes", "No", ""];

    //
    // const IsActiveDropdown = () => {
    //     return (
    //         <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
    //             <InputLabel sx={{ ml: 1}} htmlFor="source">Active</InputLabel>
    //         <Select
    //             {...register('isActive', { required: false })}
    //             labelId="demo-simple-select-filled-isActive"
    //             id="isActive"
    //             FreeSolo={true}
    //             variant="filled"
    //             label="isActive"
    //             value={isActiveDropdown}
    //             sx={{width: 150}}
    //             onChange={handleIsActiveChange}
    //             // onChange={(e) => setIsActiveDropdown(e.target.value)}
    //         >
    //             {options.map((option, idx) => (
    //                 <option key={idx} value={option}>
    //                     {option === "" ? "(None)" : option}
    //                 </option>
    //             ))}
    //         </Select>
    //         </FormControl>
    //     );
    // };
    // const IsActiveDropdown = ({ options = ['', 'Yes', 'No'] }) => {
    //     // const [isActive, setIsActive] = useState('');
    //
    //     return (
    //         <FormControl variant="filled" sx={{ pr: 5, minWidth: 200 }}>
    //             <InputLabel id="isActive-label">Active</InputLabel>
    //             <Select
    //                 labelId="isActive-label"
    //                 id="isActive"
    //                 label="Active"
    //                 value={selectorIsActive || ''}
    //                 onChange={(e) =>
    //                     dispatchData(changeInterestSearch({
    //                         isActive: e.target.value
    //                     }))
    //                 }
    //                 // onChange={(e) => setIsActive(e.target.value)}
    //                 sx={{ width: 150 }}
    //              variant="filled">
    //                 {options.map((opt, i) => (
    //                     <MenuItem key={i} value={opt}>
    //                         {opt === '' ? '(None)' : opt}
    //                     </MenuItem>
    //                 ))}
    //             </Select>
    //         </FormControl>
    //     );
    // };

    const IsActiveDropdown = ({
                                  options = ['', 'Yes', 'No'],
                                  value,
                                  onChange
                              }) => {

        return (

            <FormControl
                variant="filled"
                sx={{ pr: 5, minWidth: 200 }}
            >

                <InputLabel id="isActive-label">
                    Active
                </InputLabel>

                <Select
                    labelId="isActive-label"
                    id="isActive"
                    label="Active"
                    value={value || ''}
                    onChange={onChange}
                    sx={{ width: 150 }}
                    variant="filled"
                >

                    {options.map((opt, i) => (

                        <MenuItem
                            key={i}
                            value={opt}
                        >

                            {opt === '' ? '(None)' : opt}

                        </MenuItem>

                    ))}

                </Select>

            </FormControl>
        );
    };
    // export default IsActiveDropdown;



    function onSubmit(data) {
        console.log("here's my exchange search data before I submit it ")
        console.log({data});
        dispatchData(changeExchangeSearch({
            // searchData: data
            idFrom: data.idFrom,
            idTo: data.idTo,
            externalIdFrom: data.externalIdFrom,
            externalIdTo: data.externalIdTo,
            rateDateFrom: data.rateDateFrom,
            rateDateTo: data.rateDateTo,
            currencyFrom: data.currencyFrom,
            currencyTo: data.currencyTo,
            source: data.source,
            isActive: data.isActive
        }));
        dispatchData(changeExchange({
            exchangeGridRefresh: true
        }));
    };


    const handleCurrencyFromChange = (currencyFromEvent) => {
        setSelectedCurrencyFrom(currencyFromEvent.target.value);
        console.log("This is for the selected Currency From");
        console.log(currencyFromEvent.target.value);
    };

    const handleCurrencyToChange = (currencyToEvent) => {
        setSelectedCurrencyTo(currencyToEvent.target.value);
        console.log("This is for the selected Currency To");
        console.log(currencyToEvent.target.value);
    };

    const handleSourceChange = (sourceEvent) => {
        setSelectedSource(sourceEvent.target.value);
        console.log("This is for the selected Source");
        console.log(sourceEvent.target.value);
    };



    const handleClear = () => {

        reset({
            idFrom: '',
            idTo: '',
            externalIdFrom: '',
            externalIdTo: '',
            rateDateFrom: '',
            rateDateTo: '',
            currencyFrom: '',
            currencyTo: '',
            source: '',
            selectdSource: '',
            isActive: ''
        });

        setSelectedSource('');
        setSelectedIsActive('');
        setSelectedCurrencyFrom('');
        setSelectedCurrencyTo('');

        gridClear();

    };

    const handleIsActiveChange = (isActiveEvent) => {
        setSelectedIsActive(isActiveEvent.target.value);
        console.log("This is for the selected Is Active");
        console.log(isActiveEvent.target.value);
    };

    const selectR2mRef = useRef();
    //
    // const onClear = () => {
    // };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 170, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('idFrom', { required: false })}
                               id="idFrom"   name="idFrom"  label="ID From" aria-describedby="idFrom_entry"
                               sx={{ width: 200, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('idTo', { required: false })}
                               id="idTo"   name="idTo"  label="ID To" aria-describedby="idTo_entry"
                               sx={{ width: 200, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalIdFrom', { required: false })}
                               id="externalIdFrom"   name="externalIdFrom"  label="External ID From" aria-describedby="externalIdFrom_entry"
                               sx={{ width: 220, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalIdTo', { required: false })}
                               id="externalIdTo"   name="externalIdTo"  label="External ID To" aria-describedby="externalIdTo_entry"
                               sx={{ width: 220, pr: 5 }} />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('externalId', { required: false })}*/}
                    {/*           id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    <FormDatePicker
                        name="rateDateFrom"
                        label="Rate Date From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="rateDateTo"
                        label="Rate Date To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('rateDateFrom', { required: false })}*/}
                    {/*           id="rateDateFrom"   name="rateDateFrom"  label="Rate Date From" aria-describedby="rateDateFrom_entry"*/}
                    {/*           sx={{ width: 220, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('rateDateTo', { required: false })}*/}
                    {/*           id="rateDateTo"   name="rateDateTo"  label="Rate Date To" aria-describedby="rateDateTo_entry"*/}
                    {/*           sx={{ width: 220, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>

                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="currencyFrom">Currency From</InputLabel>
                        <Select
                            {...register('currencyFrom', { required: false })}
                            labelId="demo-simple-select-filled-currencyFrom"
                            id="currencyFrom"
                            FreeSolo={true}
                            variant="filled"
                            label="currencyFrom"
                            value={selectedCurrencyFrom}
                            onChange={handleCurrencyFromChange}
                            sx={{ width: 300}}
                        >
                            {currencyFromDropdown.map((currencyFromItem) =>
                                <MenuItem  FreeSolo={true} value={currencyFromItem.singleField}>{currencyFromItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="currencyTo">Currency To</InputLabel>
                        <Select
                            {...register('currencyTo', { required: false })}
                            labelId="demo-simple-select-filled-currencyTo"
                            id="currencyTo"
                            FreeSolo={true}
                            variant="filled"
                            label="currencyTo"
                            value={selectedCurrencyTo}
                            onChange={handleCurrencyToChange}
                            sx={{ width: 300}}
                        >
                            {currencyToDropdown.map((currencyToItem) =>
                                <MenuItem  FreeSolo={true} value={currencyToItem.singleField}>{currencyToItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="source">Source</InputLabel>
                        <Select
                            {...register('source', { required: false })}
                            labelId="demo-simple-select-filled-source"
                            id="source"
                            FreeSolo={true}
                            variant="filled"
                            label="source"
                            value={selectedSource}
                            onChange={handleSourceChange}
                            sx={{ width: 200}}
                        >
                            {sourceDropdown.map((sourceItem) =>
                                <MenuItem  FreeSolo={true} value={sourceItem.singleField}>{sourceItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>


                    <Controller
                        name="isActive"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <IsActiveDropdown
                                value={field.value}
                                onChange={field.onChange}
                            />
                        )}
                    />
                    {/*<FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >*/}
                    {/*    <InputLabel sx={{ ml: 1}} htmlFor="isActive">Is Active</InputLabel>*/}
                    {/*    <Select*/}
                    {/*        {...register('isActive', { required: false })}*/}
                    {/*        labelId="demo-simple-select-filled-isActive"*/}
                    {/*        id="isActive"*/}
                    {/*        FreeSolo={true}*/}
                    {/*        variant="filled"*/}
                    {/*        label="isActive"*/}
                    {/*        onChange={handleIsActiveChange}*/}
                    {/*        sx={{ width: 200}}*/}
                    {/*    >*/}
                    {/*        {isActiveDropdown.map((isActiveItem) =>*/}
                    {/*            <MenuItem  FreeSolo={true} value={isActiveItem.singleField}>{isActiveItem.singleField}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*</FormControl>*/}
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

